import { MAP_TYPES } from '@deck.gl/carto';
 
const SYSTEMICINTERSECTION_SOURCE_ID = 'systemicIntersectionSource';
 
const source = {
  id: SYSTEMICINTERSECTION_SOURCE_ID ,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'systemic_intersection_source',
};
 
export default source;